import React, { useState, useEffect } from 'react'
import { Modal, Button, Table } from 'react-bootstrap'
import { useStateValue } from '../state'
import { payments as endpoints } from '../../api_urls'
import { client } from '../../utils'
import ButterToast, { Cinnamon } from 'butter-toast'

const CommissionsToPayModal = () => {
  const [currentState, dispatch] = useStateValue()
  const [commissionsWorking, toggleCommissionsWorking] = useState(false)
  const [salesPersonMap, setSalesPersonMap] = useState({})

  useEffect(() => {
    let tempSalesPersonMap = {}
    currentState.salespeople.map(salesperson => {
      tempSalesPersonMap[salesperson.id] = salesperson
    })
    setSalesPersonMap(tempSalesPersonMap)
  }, [currentState.salespeople])

  const handleCheckBox = e => {
    const draftSalesPersonMap = { ...salesPersonMap }
    const person = salesPersonMap[e.target.name]
    person.is_selected = !person.is_selected
    draftSalesPersonMap[person.id] = person
    setSalesPersonMap(draftSalesPersonMap)
  }

  const handleRateBox = e => {
    const draftSalesPersonMap = { ...salesPersonMap }
    const personId = e.target.name.split('-')[1]
    const person = salesPersonMap[personId]
    const rate = e.target.value
    person.rate = rate
    person.amount = parseFloat(
      (parseFloat(rate) / 100) * parseFloat(currentState.newPaymentAmount)
    ).toFixed(2)
    draftSalesPersonMap[person.id] = person
    setSalesPersonMap(draftSalesPersonMap)
  }

  const submitCommissions = async () => {
    toggleCommissionsWorking(true)
    const data = {
      coursenum: currentState.newPaymentCoursenum,
      payment_item: currentState.paymentItemID,
      adHocCommissions: salesPersonMap,
    }
    client
      .post(endpoints.createNewCommissions(), data)
      .then(() => {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Success"
              content={`Successfully created the appropriate commission transactions.`}
              scheme={Cinnamon.Crisp.SCHEME_GREEN}
              icon={<i className="far fa-check fa-3x" />}
            />
          ),
        })
      })
      .catch(err => {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={err.response.data.error}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
      })
    dispatch({
      type: 'toggleCommissionPaymentModal',
      commissionModalOpen: false,
    })
    dispatch({ type: 'resetFormData' })
    toggleCommissionsWorking(false)
  }

  const displayOrCreateCommissions = () => {
    if (currentState.commissions.length > 0) {
      return currentState.commissions.map((commission, i) => (
        <tr key={i}>
          <td>{commission.user_full_name}</td>
          <td className="text-right">{commission.commission_rate * 100}%</td>
          <td className="text-right">${commission.commission_amount}</td>
        </tr>
      ))
    } else {
      return currentState.salespeople.map((salesperson, i) => {
        if (salesperson.id in salesPersonMap) {
          return (
            <tr key={i}>
              <td>
                <input
                  type="checkbox"
                  checked={salesPersonMap[salesperson.id].is_selected}
                  onChange={handleCheckBox}
                  name={salesperson.id}
                />
                {` ${salesperson['salesperson']}`}
              </td>
              <td className="text-right">
                {salesPersonMap[salesperson.id].is_selected && [
                  <input
                    type="numeric"
                    step="0.01"
                    label={salesperson.id}
                    name={`amount-${salesperson.id}`}
                    onChange={handleRateBox}
                    value={salesPersonMap[salesperson.id].rate}
                    style={{ width: '50px' }}
                    key={i}
                  />,
                  '%',
                ]}
              </td>
              <td className="text-right">
                {salesPersonMap[salesperson.id].is_selected &&
                  salesPersonMap[salesperson.id].amount}
              </td>
            </tr>
          )
        }
      })
    }
  }

  return (
    <Modal show={currentState.commissionModalOpen}>
      <Modal.Header>
        <Modal.Title>Pay Commissions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h1>
          <small>Payment Information</small>
        </h1>
        <Table condensed>
          <tbody>
            <tr>
              <td>Description</td>
              <td>{currentState.newPaymentDescription}</td>
            </tr>
            <tr>
              <td>Amount</td>
              <td>{currentState.newPaymentAmount}</td>
            </tr>
            <tr>
              <td>Stripe Transaction ID</td>
              <td>
                {currentState.newPaymentTransactionID ? (
                  currentState.newPaymentTransactionID
                ) : (
                  <i>None</i>
                )}
              </td>
            </tr>
            <tr>
              <td>Source</td>
              <td>
                {currentState.newSource ? currentState.newSource : <i>None</i>}
              </td>
            </tr>
            <tr>
              <td>Invoice Number</td>
              <td>
                {currentState.newInvoiceNumber ? (
                  currentState.newInvoiceNumber
                ) : (
                  <i>None</i>
                )}
              </td>
            </tr>
            <tr>
              <td>Course Number</td>
              <td>{currentState.newPaymentCoursenum}</td>
            </tr>
          </tbody>
        </Table>
        <div>
          <h1>
            <small>Associated Commissions</small>
          </h1>
          <Table bordered condensed>
            <thead>
              <tr>
                <th scope="col">Recipient</th>
                <th
                  className="text-center"
                  scope="col"
                  style={{ width: '80px' }}
                >
                  Rate
                </th>
                <th
                  className="text-center"
                  scope="col"
                  style={{ width: '80px' }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>{displayOrCreateCommissions()}</tbody>
          </Table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={() => {
            dispatch({
              type: 'toggleCommissionPaymentModal',
              commissionModalOpen: false,
            })
            dispatch({ type: 'resetFormData' })
          }}
          className="btn-myed btn-default-myed"
        >
          <span className="far fa-times fa-fw mr-2" /> No, skip and close
        </Button>
        <Button
          onClick={() => submitCommissions()}
          className="btn-myed btn-primary-myed"
          bsStyle="primary"
          disabled={commissionsWorking}
        >
          <span
            className={
              !commissionsWorking
                ? 'far fa-check fa-fw mr-2'
                : 'far fa-spinner fa-spin fa-fw mr-2'
            }
          />{' '}
          Pay Commissions
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CommissionsToPayModal
